import React, { useState, useEffect } from "react";
import { Container, Card, Modal, Header } from "semantic-ui-react";
import { postDatasetRequestAccess } from "../../actions/dataConsoleAction";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../../styles/MobileApprovedDataset.css";

const MobileOthersDataset = ({
  data = [], // Initialize data with an empty array
  showToaster,
  setDeleteStatus,
  loaderFlag,
  result,          // Callback to update data in parent
  newResult,
  request,          // Callback to update data in parent
  statusChange,
  updateLatestDataset,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Modal and request state
  const [openModal, setOpenModal] = useState(false);
  const [datasetRowId, setDatasetRowId] = useState("");
  const [selectedDatasetName, setSelectedDatasetName] = useState("");
  const [isRequesting, setIsRequesting] = useState(false);

  // Called when user clicks "Request access"
  const handleRequestAccess = (datasetID, datasetName) => {
    updateLatestDataset();
    setDatasetRowId(datasetID);
    setSelectedDatasetName(datasetName);
    setOpenModal(true);
  };

  // Confirm request – optimistically update status and call dispatch
  const confirmRequestAccess = async () => {
    setIsRequesting(true);
    setOpenModal(false);

    // Optimistically update UI to show "Pending Approval"
    result((prevData) =>
      prevData.map((item) => {
        if (item.id === datasetRowId) {
          return { ...item, accessUsers: [{ accessType: "RequestPending" }] };
        }
        return item;
      })
    );

    try {
      await dispatch(postDatasetRequestAccess({ datasets: [datasetRowId] }));
      showToaster(
        `Access requested for '${selectedDatasetName}' successfully`,
        "success"
      );
      updateLatestDataset();
      if (typeof request === "function") {
        request(false);
      }
      statusChange(true);
    } catch (error) {
      console.error("Error requesting DataSet:", error);
      setDeleteStatus(true);
      showToaster("Something went wrong", "error");
      // Optionally, revert the optimistic update if needed.
    }
    setIsRequesting(false);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  // Card component for each dataset row
  const DocumentCard = ({ dataset, status, action }) => (
    <Card fluid>
      <Card.Content>
        <Card.Header>{dataset}</Card.Header>
        <Card.Meta>
          <div>
            <div className="mobile-other-dataset-document-card">
              <p>Status</p>
              <p>{status}</p>
            </div>
            <div className="mobile-other-dataset-document-card-last">
              <p>Action</p>
              <p>{action}</p>
            </div>
          </div>
        </Card.Meta>
      </Card.Content>
    </Card>
  );

  return (
    <div
      className="mobile-others-dataset-wrapper"
      style={{ height: "80vh", overflowY: "auto" }}
    >
      <Container>
        {data && data.length > 0 ? (
          data.map((row) => {
            // Determine status text
            let statusText = <span className="NotRequested">Not Requested</span>;
            if (row.accessUsers && row.accessUsers.length > 0) {
              const accessType = row.accessUsers[0].accessType;
              if (accessType === "RequestPending") {
                statusText = (
                  <span className="pendingApproval">Pending Approval</span>
                );
              } else if (accessType === "Denied") {
                statusText = <span className="rejectedStatus">Rejected</span>;
              }
            }

            // Determine action button – if already requested, disable click
            let actionButton;
            if (
              row.accessUsers &&
              row.accessUsers.length > 0 &&
              row.accessUsers[0].accessType === "RequestPending"
            ) {
              actionButton = (
                <div className="mobile-request-access">
                  <img
                    className="tableButtonHover"
                    src="/images/green-key.svg"
                    alt="Requested"
                    data-cy="dataset-request-link"
                  />
                  Request access
                </div>
              );
            } else {
              actionButton = (
                <div
                  className="mobile-request-access"
                  onClick={() => handleRequestAccess(row.id, row.datasetName)}
                >
                  <img
                    className="tableButton"
                    src="/images/green-key.svg"
                    alt="Request Access"
                    style={{ cursor: "pointer" }}
                    data-cy="dataset-request-link"
                  />
                  Request access
                </div>
              );
            }

            return (
              <DocumentCard
                key={row.id}
                dataset={row.datasetName}
                status={statusText}
                action={actionButton}
              />
            );
          })
        ) : (
          <p>No data available.</p>
        )}
      </Container>

      {/* Confirmation Modal */}
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        size="tiny"
        className="add-document-model deletePopup requestPopup"
      >
        <Modal.Content>
          <Header as="h3">Request Access</Header>
          <p>
            Are you sure you want to request dataset access for "
            {selectedDatasetName}"?
          </p>
        </Modal.Content>
        <Modal.Actions>
          <button
            className="cancel-btn"
            onClick={handleCloseModal}
            data-cy="cancel-dataset-request"
          >
            Cancel
          </button>
          <button
            className="add-btn"
            onClick={confirmRequestAccess}
            data-cy="request-dataset-confirm"
          >
            Request
          </button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

export default MobileOthersDataset;